<template>
  <div id="modalWchatTaskSubuserBySupplier" class="modal fade">
    <div
      class="modal-dialog modal-dialog-vertical-center modal-md"
      role="document"
    >
      <div class="modal-content bd-0 tx-14">
        <modal-loading :show="!canSubmit"></modal-loading>
        <div class="modal-body pd-25 model-auto-h">
          <div>
            <p class="tx-center tx-16 tx-gray-900">
              {{ $t("subuser.我有货现在开通微信服务号啦！") }}
            </p>
            <p class="tx-center tx-gray-600">
              {{
                $t("subuser.关注服务号，可随时管理您的供应链订单，财务账单。")
              }}
            </p>
            <div class="tx-center tx-gray-600">
              <a
                href="javascript:;"
                :style="{
                  backgroundImage:
                    'url(' + (codeUrl ? codeUrl : 'img/loading-img.png') + ')',
                  backgroundSize: '100%',
                }"
                style="
                  display: block;
                  margin: 0 auto;
                  width: 200px;
                  height: 200px;
                "
              ></a>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-center">
          <button
            type="button"
            class="
              btn btn-primary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            data-dismiss="modal"
          >
            {{ $t("subuser.好的") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["user_id", "sub_user_id", "open"],
  data() {
    return {
      canSubmit: true,
      codeUrl: "",
      qrCodeId: "",
    };
  },
  watch: {
    open() {
      this.getQrcodeUrl();
    },
  },
  methods: {
    getQrcodeUrl() {
      let vm = this;
      vm.canSubmit = false;
      vm.codeUrl = "";
      $.api_call(
        "api.Wx.getQrcodeUrl",
        {
          userId: parseInt(vm.user_id),
          subUserId: parseInt(vm.sub_user_id),
        },
        function (r) {
          vm.canSubmit = true;
          if (r.ErrorCode == "9999") {
            let img = new Image();
            img.src = r.Data.Results.qrcodeUrl;
            img.onload = () => {
              vm.codeUrl = img.src;
            };
            vm.run();
            vm.qrCodeId = r.Data.Results.sceneId;
            if (vm.qrCodeId.status == 2) {
              vm.stop(wx);
              ShowTip(vm.qrCodeId.message, "danger");
              $("#modalWchatTaskSubuserBySupplier").modal("hide");
            }
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(vm);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    run() {
      let vm = this;
      vm.stop(wx);
      let openId = "";
      let wx = setInterval(function () {
        $.api_call(
          "api.Wx.getBindSuccess",
          {
            sceneId: vm.qrCodeId,
          },
          function (r) {
            if (r.ErrorCode == "9999") {
              openId = r.Data.Results.sceneId.userInfo.wxOpenId;
              if (r.Data.Results.sceneId.status == 2) {
                vm.stop(wx);
                ShowTip(r.Data.Results.sceneId.message, "danger");
                $("#modalWchatTaskSubuserBySupplier").modal("hide");
              }
            } else {
              if (r.ErrorCode == "1002") {
                userFailure(vm);
              } else {
                ShowTip(r.Message, "danger");
                vm.stop(wx);
              }
            }
          }
        );
        if (openId !== null && openId !== "" && openId !== undefined) {
          vm.stop(wx);
          $("#modalWchatTaskSubuserBySupplier").modal("hide");
          setTimeout(function () {
            ShowTip(this.$t("subuser.该子账号已成功绑定微信"), "success");
          }, 300);
          vm.$parent.getSubuserList();
        }
        if ($("#modalWchatTaskSubuserBySupplier").is(":hidden")) {
          vm.stop(wx);
        }
      }, 1000);
    },
    stop(timer) {
      clearInterval(timer);
    },
  },
};
</script>